import { Box, CircularProgress, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import * as React from 'react';
import { getUserByIdAtom } from '../jotai/atoms';

export interface UserProfileProps {
  uid: string;
  component?: React.ReactNode;
}

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden'
  },
  icon: {
    width: 48
  },
  text: {
    maxWidth: '15vw',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  noName: {
    fontStyle: 'italic'
  }
} as const;

export function UserProfile(props: UserProfileProps) {
  // 必要に応じてユーザーを取得する（Jotai版）
  const userLoadable = useAtomValue(loadable(getUserByIdAtom(props.uid)));

  return (
    <Box sx={styles.root}>
      {userLoadable.state === 'hasData' ? (
        <>
          <Box
            component="img"
            src={userLoadable.data?.iconUrl || ''}
            sx={styles.icon}
            alt=""
          />
          <Typography
            variant="body1"
            sx={[styles.text, !userLoadable.data?.displayName && styles.noName]}
          >
            {userLoadable.data?.displayName ||
              'ニックネームが設定されていません'}
          </Typography>
        </>
      ) : userLoadable.state === 'hasError' ? (
        <Typography variant="body1" sx={styles.text}>
          エラーが発生しました
        </Typography>
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
}
